export const posts = [
  {
    "date": "2026.04.12",
    "link": "https://gist.github.com/lazywithclass/88ab4cc0d8551bd2b226396bab7b60e9",
    "title": "Clojure transducers"
  },
  {
    "date": "2024.06.25",
    "link": "https://gist.github.com/lazywithclass/f9d8494075d01205d201e1bdddbc799b",
    "title": "A better Youtube experience"
  },
  {
    "date": "2024.05.29",
    "link": "https://gist.github.com/lazywithclass/53a8bfb3bd6a939a65f3bc45c2899635",
    "title": "Long time no see"
  },
  {
    "date": "2018.03.21",
    "link": "https://gist.github.com/lazywithclass/8247698aef5ac50476406dc74f26fa93",
    "title": "Bandwidth throttling on FreeBSD"
  },
  {"date": "2017.11.21",
   "link": "https://gist.github.com/lazywithclass/3e53b670f7ec61c6b700931b2770db2a",
   "title": "[Teaching programming] Lesson six"
  },
  {"date": "2017.11.14",
   "link": "https://gist.github.com/lazywithclass/3f87d606cdb3c22a79b44e86a6376786",
   "title": "[Teaching programming] Lesson five"
  },
  {"date": "2017.11.08",
   "link": "https://gist.github.com/lazywithclass/a945e91db858fed5a4639a6e18d4c3c2",
   "title": "[Teaching programming] Lesson four"
  },
  {"date": "2017.10.25",
   "link": "https://gist.github.com/lazywithclass/0912351809818faeadde1dd6a0d7f8e5",
   "title": "[Teaching programming] Lesson three"
  },
  {"date": "2017.10.16",
   "link": "https://gist.github.com/lazywithclass/03a3e5cdfcc4bfd79e5a351b8f2b6bb6",
   "title": "[Teaching programming] Lesson two"
  },
  {"date": "2017.10.09",
   "link": "https://gist.github.com/lazywithclass/f01cb09cf3465c412706dff3dd853ebc",
   "title": "[Teaching programming] Lesson one"
  },
  {"date": "2017.09.19",
   "link": "https://gist.github.com/lazywithclass/7f4b96f72c1c0bd29ce71fc8b56c8b4d",
   "title": "161"
  },
  {"date": "2017.07.26",
   "link": "https://gist.github.com/lazywithclass/e4381f4499d8595e92d5f15ac3f52907",
   "title": "Learning Vue.js"
  },
  {"date": "2017.07.12",
   "link": "https://gist.github.com/lazywithclass/5ba4ba7198c195a661f62c08e49deef1",
   "title": "Implementing racket/trace in JavaScript"
  },
  {"date": "2017.06.13",
   "link": "https://gist.github.com/lazywithclass/6491d057db1f35c8f737e2e74dfbf073",
   "title": "On tests, take home problems, and a HackerRank bookmarklet"
  },
  {"date": "2017.05.16",
   "link": "https://gist.github.com/lazywithclass/86644ea379d8de27979d2bd6c97421fd",
   "title": "On whiteboard interviews"
  },
  {"date": "2017.05.04",
   "link": "",
   "title": "[RC Diary] Last day, you don't expect me to write a blog entry, do you? (-26)"
  },
  {"date": "2017.05.03",
   "link": "https://gist.github.com/lazywithclass/e08fea58a6b750365cddde2a6ee3c2f4",
   "title": "[RC Diary] Interviews back to back (-27)"
  },
  {"date": "2017.05.02",
   "link": "https://gist.github.com/lazywithclass/0f93688ed223039981becb67e2319237",
   "title": "[RC Diary] You guessed it (-28)"
  },
  {"date": "2017.05.01",
   "link": "https://gist.github.com/lazywithclass/8d703f91d6a6c46834771ce0e0928546",
   "title": "[RC Diary] Idris (-29)"
  },
  {"date": "2017.04.30",
   "link": "https://gist.github.com/lazywithclass/423fdf48a68de146b01c56137a32dedd",
   "title": "[RC Diary] Idris (-30)"
  },
  {"date": "2017.04.29",
   "link":  "",
   "title": "[RC Diary] A bit of rest (-31)"
  },
  {"date": "2017.04.28",
   "link": "https://gist.github.com/lazywithclass/5e82e7e23d7af2ba25a560c9107bd6ab",
   "title": "[RC Diary] Scheme interpreter, lambda calculus, and wtf is this (-32)"
  },
  {"date": "2017.04.27",
   "link": "https://gist.github.com/lazywithclass/480fafe61e21bb553699ff390204eab1",
   "title": "[RC Diary] Mock interviews and the little schemer (-33)"
  },
  {"date": "2017.04.26",
   "link": "https://gist.github.com/lazywithclass/38b4080c4366f8013588c4695d61a7b3",
   "title": "[RC Diary] Interviews and exercises (-34)"
  },
  {"date": "2017.04.25",
   "link": "https://gist.github.com/lazywithclass/da7f409bfe1044fefb82261ed7f57feb",
   "title": "[RC Diary] Implementing a trie in Racket (-35)"
  },
  {"date": "2017.04.25",
   "link": "https://gist.github.com/lazywithclass/6af94f652cd59796e9592a5ea5772d17",
   "title": "Looking at the most beautiful program ever written - part 1"
  },
  {"date": "2017.04.24",
   "link": "https://gist.github.com/lazywithclass/025e83daf530f4aa8941b7a474445137",
   "title": "[RC Diary] Interpreter and interviews(-36)"
  },
  {"date": "2017.04.23",
   "link": "https://gist.github.com/lazywithclass/94cb9ae3d507d6f13942f510e13154e4",
   "title": "[RC Diary] Interpreter (-37)"
  },
  {"date": "2017.04.22",
   "link": "",
   "title": "[RC Diary] A bit of rest (-38)"
  },
  {"date": "2017.04.21",
   "link": "https://gist.github.com/lazywithclass/d288d157349da518b019a2cd52b225dc",
   "title": "[RC Diary] Interviews, mock interviews, more mock interviews, and Dota (-39)"
  },
  {"date": "2017.04.20",
   "link": "https://gist.github.com/lazywithclass/e07e81e2b875c44df55058aa1b614715",
   "title": "[RC Diary] The most beautiful program ever written, and speed reading app (-40)"
  },
  {"date": "2017.04.19",
   "link": "",
   "title": "[RC Diary] A bit of rest (-41)"
  },
  {"date": "2017.04.18",
   "link": "https://gist.github.com/lazywithclass/baf3233a470f59b548247cf386bad573",
   "title": "[RC Diary] Interview exercise (-42)"
  },
  {"date": "2017.04.17",
   "link": "https://gist.github.com/lazywithclass/10d1d646275e07ff51a4bef9fff8c569",
   "title": "[RC Diary] Jobs hunt, climbing the Scala, and speed reading app (-43)"
  },
  {"date": "2017.04.16",
   "link": "https://gist.github.com/lazywithclass/599f6582eaa4916e7c64a22e255b636f",
   "title": "[RC Diary] Scala (-44)"
  },
  {"date": "2017.04.15",
   "link": "https://gist.github.com/lazywithclass/d9143dbbb3a60d8fa5bc7aac31cbab01",
   "title": "[RC Diary] Scala (-45)"
  },
  {"date": "2017.04.14",
   "link": "https://gist.github.com/lazywithclass/e544644a3bcaf0958accb6679f026ab8",
   "title": "[RC Diary] Interviews (-46)"
  },
  {"date": "2017.04.13",
   "link": "https://gist.github.com/lazywithclass/54c4ecda5abc33ee6067618600ee05b1",
   "title": "[RC Diary] Progressing (-47)"
  },
  {"date": "2017.04.12",
   "link": "https://gist.github.com/lazywithclass/4d6b596c2a93750eacaba12e4786ab72",
   "title": "[RC Diary] Scheming today is the most appropriate thing to do (-48)"
  },
  {"date": "2017.04.11",
   "link": "https://gist.github.com/lazywithclass/4fb43122337f845a9c58dc5bebc0f0b7",
   "title": "[RC Diary] Speed reading app, and then mind blank(-49)"
  },
  {"date": "2017.04.10",
   "link": "https://gist.github.com/lazywithclass/9bb1f36b06cb0a336000a4c481705458",
   "title": "[RC Diary] Refucktoring, winston-cloudwatch, and jobs (-50)"
  },
  {"date": "2017.04.09",
   "link": "",
   "title": "[RC Diary] A bit of rest (-51)"
  },
  {"date": "2017.04.08",
   "link": "",
   "title": "[RC Diary] A bit of rest (-52)"
  },
  {"date": "2017.04.07",
   "link": "https://gist.github.com/lazywithclass/6bb31552874302b4c15f6c00829da6c9",
   "title": "[RC Diary] Interviews (-52)"
  },
  {"date": "2017.04.06",
   "link": "https://gist.github.com/lazywithclass/2ff92b738b7f1fe1e9d6d35770373a21",
   "title": "[RC Diary] Speed reading app (-53)"
  },
  {"date": "2017.04.05",
   "link": "https://gist.github.com/lazywithclass/a7b5320b1ff0cd0547abfcb245b97bee",
   "title": "[RC Diary] winston-cloudwatch, Elm, the little schemer, and jobs (-55)"
  },
  {"date": "2017.04.04",
   "link": "https://gist.github.com/lazywithclass/95cf24454897b3bc0ec83a4f36dcda09",
   "title": "[RC Diary] Raging over SICP 1.2 and winston-cloudwatch (-56)"
  },
  {"date": "2017.04.03",
   "link": "https://gist.github.com/lazywithclass/665b3695f81c376f440498012221dea9",
   "title": "[RC Diary] Hammock speed reading development (-57)"
  },
  {"date": "2017.04.02",
   "link": "https://gist.github.com/lazywithclass/afa54fcb7e53d65c27b2f12aea4d5bbe",
   "title": "[RC Diary] SICP and speed reading (-58)"
  },
  {"date": "2017.04.01",
   "link": "https://gist.github.com/lazywithclass/abe68392f4d2bfe9181dab60fa769cff",
   "title": "[RC Diary] Speed reading (-59)"
  },
  {"date": "2017.03.31",
   "link": "https://gist.github.com/lazywithclass/9786202d713cd2d75d022d482d37eff9",
   "title": "[RC Diary] Mock interviews (-60)"
  },
  {"date": "2017.03.30",
   "link": "https://gist.github.com/lazywithclass/39bb8dde01da04d959ba7f43ffb79c99",
   "title": "[RC Diary] Mutating one thing at a time (-61)"
  },
  {"date": "2017.03.29",
   "link": "https://gist.github.com/lazywithclass/49e204195f29c26fed9569132af5bdc4",
   "title": "[RC Diary] Low energy (-62)"
  },
  {"date": "2017.03.28",
   "link": "https://gist.github.com/lazywithclass/03ca12a82186b20d95452670f2f80b17",
   "title": "[RC Diary] Getting data to have Cerebro in good shape (-63)"
  },
  {"date": "2017.03.27",
   "link": "https://gist.github.com/lazywithclass/924e93e366b0bf76788eb1bc56091b43",
   "title": "[RC Diary] New batch and Cerebro thoughts (-64)"
  },
  {"date": "2017.03.26",
   "link": "https://gist.github.com/lazywithclass/4ee377f57afeabd800f40a3911cbe231",
   "title": "[RC Diary] Online test and the memory castle (-65)"
  },
  {"date": "2017.03.25",
   "link": "",
   "title": "[RC Diary] A bit of rest (-66)"
  },
  {"date": "2017.03.24",
   "link": "https://gist.github.com/lazywithclass/c88471fa8f2b1ed0d6b3b03a5aad7ccc",
   "title": "[RC Diary] Interviewing (-67)"
  },
  {"date": "2017.03.23",
   "link": "https://gist.github.com/lazywithclass/b7cf5f843309d6ba3b89c6156f506a33",
   "title": "[RC Diary] Lisping (-68)"
  },
  {"date": "2017.03.22",
   "link": "https://gist.github.com/lazywithclass/d967adb32700b75e172ba189bcecfc38",
   "title": "[RC Diary] winston-cloudwatch bug, jobs, and the little schemer (-69)"
  },
  {"date": "2017.03.21",
   "link": "https://gist.github.com/lazywithclass/ca6aa383c37303fd00fe022634c29a95",
   "title": "[RC Diary] winston-cloudwatch and cerebro (-70)"
  },
  {"date": "2017.03.20",
   "link": "https://gist.github.com/lazywithclass/921a258ee46ae066d2ca4aa7036f2f96",
   "title": "[RC Diary] Stratovarius paced day, and oh, yes, CVs (-71)"
  },
  {"date": "2017.03.19",
   "link": "https://gist.github.com/lazywithclass/0312e50dd28f967bde7780d94f811130",
   "title": "[RC Diary] Working from home, little scheming, Noam Chomsky (-72)"
  },
  {"date": "2017.03.18",
   "link": "",
   "title": "[RC Diary] A bit of rest (-73)"
  },
  {"date": "2017.03.17",
   "link": "https://gist.github.com/lazywithclass/fe0b223dc1e7dd079b80f48952ddeecd",
   "title": "[RC Diary] Interview mock, helping a recurser figuring out how to code her ideas (-74)"
  },
  {"date": "2017.03.16",
   "link": "https://gist.github.com/lazywithclass/0d4aea4b56d1ff5ed4b0ffc880c0b8cc",
   "title": "[RC Diary] I'm so fed up with this cold (-75)"
  },
  {"date": "2017.03.15",
   "link": "https://gist.github.com/lazywithclass/dedcea702eb1f24d350b0e4e73d9c66e",
   "title": "[RC Diary] Still so cold in NY (-76)"
  },
  {"date": "2017.03.14",
   "link": "https://gist.github.com/lazywithclass/b3c6033532e5a51a8519caa3bc100300",
   "title": "[RC Diary] Lazy evaluation first steps (-77)"
  },
  {"date": "2017.03.13",
   "link": "https://gist.github.com/lazywithclass/0adb97f055e2e89b9e0246598ce7f7b1",
   "title": "[RC Diary] Project lamp, helping with tests, and the old lady from the mart (-78) "
  },
  {"date": "2017.03.12",
   "link": "",
   "title": "[RC Diary] A bit of rest (-79)"
  },
  {"date": "2017.03.11",
   "link": "https://gist.github.com/lazywithclass/f11498f9bc5b7478e26532f348679ede",
   "title": "[RC Diary] It's all about mutations (-80) "
  },
  {"date": "2017.03.10",
   "link": "https://gist.github.com/lazywithclass/52e5052bbb470bee4420b8805eb5a110",
   "title": "[RC Diary] Explaining tests and mock interviews (-81) "
  },
  {"date": "2017.03.09",
   "link": "https://gist.github.com/lazywithclass/cb60e95041cbdb7f2836d4b45a65b1a0",
   "title": "[RC Diary] Good progress and activism (-82)"
  },
  {"date": "2017.03.08",
   "link": "https://gist.github.com/lazywithclass/83d36d1684665d660108acd29eac5cbd",
   "title": "[RC Diary] Still a bit under the rejection thing (-83)"
  },
  {"date": "2017.03.07",
   "link": "https://gist.github.com/lazywithclass/8af27664aac75c5f207b0f9f30f9c2f9",
   "title": "[RC Diary] Rejection (-84)"
  },
  {"date": "2017.03.06",
   "link": "https://gist.github.com/lazywithclass/4ce0b0b44f48c0406a63c6ffb71dc07d",
   "title": "[RC Diary] Good progress and activism (-85)"
  },
  {"date": "2017.03.05",
   "link": "https://gist.github.com/lazywithclass/077f6b6ecc582f058b27c0a4dcac3ce0",
   "title": "[RC Diary] Out of the tar pit (-86)"
  },
  {"date": "2017.03.04",
   "link": "https://gist.github.com/lazywithclass/6affd754cbf80feeb2b1fc36403282ce",
   "title": "[RC Diary] Whitepapers love (-87)"
  },
  {"date": "2017.03.03",
   "link": "https://gist.github.com/lazywithclass/e7f6237f51e70c386997dbf168adce78",
   "title": "[RC Diary] Interview preps, emptying the backlog (-88)"
  },
  {"date": "2017.03.02",
   "link": "https://gist.github.com/lazywithclass/f9572d7fcb6bd4a1f11fe1ebce035d48",
   "title": "[RC Diary] Presentations and stuff working (-89)"
  },
  {"date": "2017.03.01",
   "link": "https://gist.github.com/lazywithclass/fae8a4afbc17233e59d4bc1c043b81d4",
   "title": "[RC Diary] For every step there's another hole to jump (-90)"
  },
  {"date": "2017.02.28",
   "link": "https://gist.github.com/lazywithclass/77db183e07fe49be05ebcf5a78aac424",
   "title": "[RC Diary] You never forget your first alive mutant (-91)"
  },
  {"date": "2017.02.27",
   "link": "https://gist.github.com/lazywithclass/feb866657095dfeaa3a746245e1ecb79",
   "title": "[RC Diary] Cerebro great progress and preparing talks, more thoughts (-92)"
  },
  {"date": "2017.02.26",
   "link": "https://gist.github.com/lazywithclass/01b2ef10a8884ee87175a71bd2f7edf9",
   "title": "[RC Diary] Two weeks of RC ten to go (-93)"
  },
  {"date": "2017.02.25",
   "link": "https://gist.github.com/lazywithclass/e3d1e52affa3bec7dae2effbe1efff44",
   "title": "[RC Diary] Mock interviews (-94)"
  },
  {"date": "2017.02.24",
   "link": "https://gist.github.com/lazywithclass/bbce6317908b60eda02955f42b92471b",
   "title": "[RC Diary] Videos and not getting ill (-95)"
  },
  {"date": "2017.02.23",
   "link": "https://gist.github.com/lazywithclass/9cf5fdac8db27f872cfbec87fca3bf69",
   "title": "[RC Diary] Presenting and slowly, slowly progressing on Cerebro (-96)"
  },
  {"date": "2017.02.22",
   "link": "https://gist.github.com/lazywithclass/f1f5cacff3e8adab95e64eb640ab8e56",
   "title": "[RC Diary] Web dev 101, finished first version of project-lamp first chapter (-97)"
  },
  {"date": "2017.02.21",
   "link": "https://gist.github.com/lazywithclass/332319d70f3f7ef92bb77445694d3e77",
   "title": "[RC Diary] ? (-98)"
  },
  {"date": "2017.02.20",
   "link": "https://gist.github.com/lazywithclass/7c4207b21d1ba6a999984ae464a5b720",
   "title": "[RC Diary] Bottle of beer (-99)"
  },
  {"date": "2017.02.19",
   "link": "https://gist.github.com/lazywithclass/4e4a76435624b3b9b7ab3a2790074063",
   "title": "[RC Diary] Wheel of fortune (-100)"
  },
  {"date": "2017.02.18",
   "link": "https://gist.github.com/lazywithclass/ebbf7b955a00baacb78ac2978e0ee0f3",
   "title": "[RC Diary] Pongo and Perdita (-101)"
  },
  {"date": "2017.02.17",
   "link": "https://gist.github.com/lazywithclass/de5a86381ec1444e9a6e1996d6b157ae",
   "title": "[RC Diary] Algorithms data structures, Cerebro, thoughts, and 42 (-102)"
  },
  {"date": "2017.02.16",
   "link": "https://gist.github.com/lazywithclass/7a26a9419c9fe197422f4d629afc3f1f",
   "title": "[RC Diary] Recursion, folding, and slow learning (-103)"
  },
  {"date": "2017.02.15",
   "link": "https://gist.github.com/lazywithclass/216edccadda559bbdd22864f727833c9",
   "title": "[RC Diary] Hello RC! (-104)"
  },
  {"date": "2017.02.14",
   "link": "https://gist.github.com/lazywithclass/6a84ee97ec8ebb6d4ae0d94f67ef9149",
   "title": "[RC Diary] Second day at RC (-105)"
  },
  {"date": "2017.02.13",
   "link": "https://gist.github.com/lazywithclass/6054a6882f7217ffd7526e8a37a2b74d",
   "title": "[RC Diary] First day at RC, plans (-106)"
  },
  {"date": "2017.01.22",
   "link": "https://gist.github.com/lazywithclass/1ecdeab9e2e222d87cf65a8631eeec6d",
   "title": "[COMP300E] problems and tinder (-128)"
  },
  {"date": "2017.01.15",
   "link": "https://gist.github.com/lazywithclass/ae6a5d59924a6b0980b343b85808a31d",
   "title": "[COMP300E] lecture (-135)"
  },
  {"date": "2017.01.10",
   "link": "https://gist.github.com/lazywithclass/e567eaffb7f5a019e9062e517422e84f",
   "title": "[COMP300E] and struggle on dynamic programming (-140)"
  },
  {"date": "2016.12.28",
   "link": "https://gist.github.com/lazywithclass/1de508acf83d4976991567afe90a726f",
   "title": "[CSE373] lectures, dynamic programming (-153)"
  },
  {"date": "2016.12.26",
   "link": "https://gist.github.com/lazywithclass/6674fee20d584b5a553e2935b601d4a1",
   "title": "[CSE373] lecture, following on dynamic programming (-155)"
  },
  {"date": "2016.12.22",
   "link": "https://gist.github.com/lazywithclass/7a9aad74ff27d9634f694b52d527451e",
   "title": "[CSE373] lectures, dynamic programming, ubuntu 16.10 daily crash (-158)"
  },
  {"date": "2016.12.21",
   "link": "https://gist.github.com/lazywithclass/269f6ae09c5d63ccca474aa090640b2b",
   "title": "[CSE373] lectures, Ubuntu 16.10 daily crash, winston-cloudwatch process inspection (-159)"
  },
  {"date": "2016.12.13",
   "link": "https://gist.github.com/lazywithclass/55b21a847e802048f6ee01016fe11509",
   "title": "[CSE373] lecture, winston-cloudwatch process inspection, Ubuntu 16.10 daily crash (-168)"
  },
  {"date": "2016.12.07",
   "link": "https://gist.github.com/lazywithclass/78a78eab8569c1125b0357ec796c8c0d",
   "title": "[CSE373] lecture, Ubuntu weirdness, winston-cloudwatch behaviour (-174)"
  },
  {"date": "2016.12.06",
   "link": "https://gist.github.com/lazywithclass/a9d6808a8bc6d232adc64eecd85c672e",
   "title": "[CSE373] lecture, work on winston-cloudwatch, Emacs xwidgets (-175)"
  },
  {"date": "2016.12.05",
   "link": "https://gist.github.com/lazywithclass/45035221dbeb532d30fe487295dc5c79",
   "title": "Attending the Recurse Center"
  },
  {"date": "2016.07.06",
   "link": "https://gist.github.com/lazywithclass/bc0e0a6bfb0bf2f76dc1d04974631fb8",
   "title": "Contract testing and free documentation"
  },
  {"date": "2016.06.01",
   "link": "https://gist.github.com/lazywithclass/4fb9da41d1f0383456acc678107d1453",
   "title": "Angularjs and unknown provider"
  },
  {"date": "2016.05.09",
   "link": "https://gist.github.com/lazywithclass/f19d9aeaf4227367916fcd9844a8a44c",
   "title": "Moving between tmux panes à la Spacemacs"
  },
  {"date": "2016.02.24",
   "link": "https://gist.github.com/lazywithclass/0679f7cc539b53e5494cacc06154e965",
   "title": "Studying Elm"
  },
  {"date": "2015.12.15",
   "link": "https://gist.github.com/lazywithclass/c09464a3af302d30120ed34dc2fb0f56",
   "title": "Loo technique"
  },
  {"date": "2015.11.06",
   "link": "https://gist.github.com/lazywithclass/0763610f63d6ad09f38f05dbc70f58b8",
   "title": "Thoughts on interviews"
  },
  {"date": "2015.10.22",
   "link": "https://gist.github.com/lazywithclass/f8615742e876237a051eb64476fd71dd",
   "title": "Logging request body in HAProxy"
  },
  {"date": "2015.10.02",
   "link": "https://gist.github.com/lazywithclass/fc620ca299c0c4a0d5ea074bb8d7f124",
   "title": "Reference an existing IAM role from a CloudFormation template in AWS"
  },
  {"date": "2015.08.05",
   "link": "https://gist.github.com/lazywithclass/ee3dd0c0e01b7d0fb26b3dc54b0d5cec",
   "title": "Building the Atreus keyboard"
  },
  {"date": "2015.07.07",
   "link": "https://gist.github.com/lazywithclass/fbcfc277ffee7479be5654303f48c494",
   "title": "Create a private github repo in an organisation using the CLI"
  },
  {"date": "2015.06.12",
   "link": "https://gist.github.com/lazywithclass/7c416e0e8176c5612915a3012fc49538",
   "title": "Breadth first and depth first, same algorithm different data structure"
  },
  {"date": "2015.06.02",
   "link": "https://gist.github.com/lazywithclass/59bafa47fbf027bc9bab140e7d293623",
   "title": "Download ajax calls responses for a set of pages"
  }
]
